import type {GateResultDto} from '@devmil/contracts';

import {
  GATE_LABEL,
  GATE_OUTCOME_CLASS,
  GATE_OUTCOME_LABEL,
} from '../../lib/format.js';

/** Os sete portões, sempre os sete, sempre na ordem aprovada. */
export const GateList = ({gates}: {gates: readonly GateResultDto[]}) => (
  <ul className="dm-gates" aria-label="Sete portões de qualidade">
    {gates.map((gate) => (
      <li key={gate.id}>
        <span>{GATE_LABEL[gate.id]}</span>
        <strong className={GATE_OUTCOME_CLASS[gate.outcome]}>
          {GATE_OUTCOME_LABEL[gate.outcome]}
        </strong>
      </li>
    ))}
  </ul>
);
